export default __webpack_public_path__ + "static/media/warning-24px.9fcdc101.svg";